import tenantConstants from '@constants';
import { t } from 'i18next';
import * as yup from 'yup';
import { strings } from '../../../constants/strings';
import { skipFieldsForField } from './listing-form-data';
import { regex } from '../../../constants/regex';

// const englishRegex = /^[^\u0600-\u06FF]+$/;
// const arabicRegex = /^[^A-Za-z]+$/;
const shouldFieldRequire = (fieldName, property_type) => {
  const skipConfig = skipFieldsForField?.[fieldName]?.property_type;
  return !(skipConfig?.[property_type]?.skipField || skipConfig?.[property_type]?.isOptional);
};

export const getPostListingValidationSchema = (locale, purposeSlug, type_id, is_mobile_verified, purpose) => {
  return yup.object().shape({
    bedrooms: yup.mixed().when('property_type', (property_type, schema) => {
      return shouldFieldRequire('bedrooms', property_type)
        ? yup.string().required(t('Please select number of bedrooms')).typeError(t('Please select number of bedrooms'))
        : schema.notRequired();
    }),

    bathrooms: yup.mixed().when('property_type', (property_type, schema) => {
      return shouldFieldRequire('bathrooms', property_type)
        ? yup
            .string()
            .required(t('Please select number of bathrooms'))
            .typeError(t('Please select number of bathrooms'))
        : schema.notRequired();
    }),
    property_type: yup.string().required(t('Please select property type')).typeError(t('Please select property type')),

    ...(!is_mobile_verified && {
      mobile: yup
        .string()
        .required(t('Please enter your number'))
        .test('format', t(strings.im.phone), (value) => {
          if (!value) return true;
          return tenantConstants.PHONE_REGEX ? tenantConstants.PHONE_REGEX.test(value) : true;
        })
        .nullable(),
    }),
    furnished: yup.mixed().when('property_type', (property_type, schema) => {
      return shouldFieldRequire('furnished', property_type)
        ? yup
            .string()
            .required(t('Please select a value for furnished'))
            .typeError(t('Please select a value for furnished'))
        : schema.notRequired();
    }),
    price: yup.mixed().when('purpose', (purpose, schema) => {
      return purpose == 1
        ? yup.number().required(t('Please enter price')).moreThan(0, t('Invalid Price')).typeError(t('Invalid Price'))
        : schema.notRequired();
    }),

    rental_frequency: yup.mixed().when('purpose', (purpose, schema) => {
      return purpose == 2 ? yup.number().required(t('Please select rental frequency')) : schema.notRequired();
    }),
    rental_price: yup.mixed().when('purpose', (purpose, schema) => {
      return purpose == 2
        ? yup.number().required(t('Please enter price')).moreThan(0, t('Invalid Price')).typeError(t('Invalid Price'))
        : schema.notRequired();
    }),

    property_title_en:
      locale == 'en'
        ? yup
            .string()
            .required(t('Please enter property title'))
            .nullable()
            .test('len', t('Minimum of 5 characters required'), (val) => val?.length >= 5)
            .test('is-english', t('Please enter your title in English only'), (val) => regex.englishRegex.test(val))
            .test('contains-alpha', t('Title must contain at least one alphabetic character'), (val) =>
              regex.onlyAlphabets.test(val),
            )
        : yup.string().nullable(),
    area: yup
      .number()
      .required(t('Please enter area'))
      .typeError(t('Invalid Area'))
      .test('is-integer-string', t('Invalid Area'), (val) => {
        const stringValue = val?.toString();
        return /^[0-9]+$/.test(stringValue);
      }),
    property_title_ar:
      locale == 'ar'
        ? yup
            .string()
            .required(t('Please enter property title ar'))
            .nullable()
            .test('len', t('Minimum of 5 characters required'), (val) => val?.length >= 5)
            .test('is-arabic', t('يرجى إدخال عنوان الأعلان بالعربي'), (val) => regex.arabicRegex.test(val))
            .test('contains-alpha', t('Title must contain at least one alphabetic character'), (val) =>
              regex.onlyArabicChar.test(val),
            )
        : yup.string().nullable(),

    property_description_ar:
      locale == 'ar'
        ? yup
            .string()
            .required(t('Please enter property description ar'))
            .nullable()
            .test('len', t('Minimum of 20 characters required'), (val) => val?.length >= 20)
            .test('is-arabic', t('يرجى إدخال وصف العقار بالعربي'), (val) => regex.arabicRegex.test(val))
            .test('contains-alpha', t('Description must contain at least one alphabetic character'), (val) =>
              regex.onlyArabicChar.test(val),
            )
        : yup.string().nullable(),

    property_description_en:
      locale == 'en'
        ? yup
            .string()
            .required(t('Please enter property description'))
            .nullable()
            .test('len', t('Minimum of 20 characters required'), (val) => val?.length >= 20)
            .test('is-english', t('Please enter your description in English only'), (val) =>
              regex.englishRegex.test(val),
            )
            .test('contains-alpha', t('Description must contain at least one alphabetic character'), (val) =>
              regex.onlyAlphabets.test(val),
            )
        : yup.string().nullable(),

    'location-info': yup
      .object({
        city: yup.object().required(t('Region is required')),
        location: yup.object().required(t('Location is required')),
      })
      .required(t('Location is required')),
  });
};
